import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getActiveUser} from '../../../apis/analysis/getMau'

export const useQueryActiveUser = (limit: number) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.analysis.getActiveUser(limit),
        queryFn: async () => {
            const {data} = await getActiveUser(limit)
            return data
        },
    })

    return {data, refetch}
}
